import React from "react";
import { useState , useEffect} from "react";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom";
import axios from "axios";
import { path } from "../../path";
import UserSelection from "./UserSelection";

const CreateAdvertiser = () => {
  const { advertiserId } = useParams();
  const initialValues = {
    email: "",
    phoneNumber: "",
    displayName: "",
    description: "",
    userId: "",
  };
  const [advertiserData, setAdvertiserData] = useState(initialValues);
  const [displayProfile, setDisplayProfile] = useState(null);
  const [userInAppProfile, setUserInAppProfile] = useState(null);
  const [userModel, setUserModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(()=>{
    if(advertiserId){
      fetchAdvertiserData(advertiserId);
    }

  },[advertiserId])

  const handleChange = (ev) => {
    setAdvertiserData((prev) => ({
      ...prev,
      [ev.target.name]: ev.target.value,
    }));
  };

  const uploadSingleFile = async (file) => {
    try {
      const {
        data: { accessToken },
      } = await axios.get(`${path}/getUploadToken`);

      if (!accessToken) {
        console.info("Unable to access Access Token");
        return;
      }

      // Phase 2: Uploading the file to Box using accessToken
      const uniqueFileName = `${Date.now()}-${file.name}`;

      const formData = new FormData();
      formData.append("file", file, uniqueFileName);
      formData.append("parent_id", "0");

      const response = await axios.post(
        "https://upload.box.com/api/2.0/files/content",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
          onUploadProgress: (progressEvent) => {
            const progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            console.info(`Upload Progress: ${progress}%`);
          },
        }
      );

      const File = response.data.entries[0];

      // Phase 3: Sending the file details to backend to get URL
      let fileData;
      try {
        const { data } = await axios.post(`${path}/genrate-Url`, {
          id: File.id,
          name: File.name,
        });
        fileData = data;
      } catch (error) {
        console.info("Generating URL error:", error.message);

        // Attempt to delete the file if URL generation fails
        try {
          const res = await axios.delete(`${path}/delete-file/${File.id}`);
          console.info("Deleted file from Box:", res.data);
        } catch (deleteError) {
          console.info("Error deleting file from Box:", deleteError.message);
        }

        // Rethrow the error after cleanup
        throw new Error("Error generating URL, file has been deleted.");
      }
      return fileData;
    } catch (error) {
      console.info("Error in uploading file:", error);
    }
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setLoading(true);
  
    // Validation Check
    if (
      !advertiserData.displayName ||
      !advertiserData.description ||
      !advertiserData.email ||
      !advertiserData.phoneNumber
    ) {
      alert("All fields are required!");
      setLoading(false);
      return;
    }
  
    if (!advertiserId && !displayProfile) {
      alert("Profile picture is required");
      setLoading(false);
      return;
    }
  
    try {
      let file;
      
      // Upload only if displayProfile exists
      if (displayProfile) {
        file = await uploadSingleFile(displayProfile);
      }
  
      const data = {
        displayName: advertiserData.displayName,
        description: advertiserData.description,
        email: advertiserData.email,
        userId: userInAppProfile?._id,
        phoneNumber: advertiserData.phoneNumber,
        ...(file ? { 
          displayPicture: file.file_url, 
          displayPictureId: file.file_id
        } : {}),
      };
  
      let response;
  
      if (advertiserId) {
        response = await axios.put(`${path}/advertiser/${advertiserId}`, data);
      } else {
        response = await axios.post(`${path}/advertiser`, data);
      }
  
      if (response.status === 200) {
        setAdvertiserData(initialValues); 
        setDisplayProfile(null);
        setUserInAppProfile(null);
        console.info("Advertiser created/updated:", response.data.data);
        history.goBack();
      }
    } catch (error) {
      alert("Error in creating advertiser. Please try again.");
      console.error("Error in creating advertiser:", error);
    } finally {
      setLoading(false);
    }
  };
  

  const fetchAdvertiserData = async (advertiserId) => {
    if (!advertiserId) {return;}  
  
    try {
      const advertiserRequest = axios.get(`${path}/advertiser/${advertiserId}`);
  
      const response = await advertiserRequest;
      if (response?.data?.data) {
        const data = response.data.data;
  
        setAdvertiserData((prev) => ({
          ...prev,
          email: data.email,
          phoneNumber: data.phoneNumber,
          displayName: data.displayName,
          description: data.description,
        }));
  
        console.info("Specific advertiser:", data);
  
        // Fetch user profile only if userId exists
        if (data.userId) {
          const profileResponse = await axios.get(`${path}/getUserData/${data.userId}`);
          if (profileResponse.status === 200) {
            setUserInAppProfile(profileResponse?.data);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching advertiser:", error);
    }
  };
  

  return (
    <div className="flex-col px-[20%] justify-center  bg-white">
      {loading && (
        <div className=" fixed w-full h-screen bg-black/40 flex items-center justify-center inset-0 z-20">
          <div className=" flex items-center gap-2">
            <div className=" w-8 h-8 rounded-full border-2 border-teal-500 border-t-white animate-spin" />
            <p className=" text-lg text-white font-semibold">{advertiserId?"Editing..":"Creating.."}</p>
          </div>
        </div>
      )}
      <div className="flex w-full fixed items-center  bg-white mb-4 h-20 space-x-5 overflow-hidden ">
        <Link to={"/marketingAdmin"}>
          <div className="flex items-center ">
            <img
              src="https://w7.pngwing.com/pngs/848/762/png-transparent-computer-icons-home-house-home-angle-building-rectangle-thumbnail.png"
              className="h-6 mr-4"
              alt="home"
            />
            <h3>Home</h3>
          </div>
        </Link>
      </div>

      <h1 className="text-xl font-bold  mb-4 text-center">
        {advertiserId?"Edit":"Create  New "} Advertiser
      </h1>
      <form className="space-y-2 py-20" onSubmit={handleSubmit}>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Email
          </label>
          <input
            type="text"
            name="email"
            value={advertiserData.email}
            onChange={handleChange}
            className=" block w-full rounded-md border border-blue-800 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
          />
        </div>

        <div className="mb-4">
          <p>User Profile:</p>
          <div
            onClick={() => setUserModal(true)}
            className="bg-teal-500 text-white px-4 py-2 rounded-md cursor-pointer">
            Select User
          </div>
          <div className="flex flex-row my-1">
            {userInAppProfile && (
              <div
                key={userInAppProfile._id}
                onClick={() => setUserInAppProfile(null)}
                className="mx-1 p-1 bg-gray-50 border border-gray-300 rounded-md cursor-pointer hover:bg-gray-300">
                {userInAppProfile.username}
              </div>
            )}
          </div>
          {userModel && (
            <div className=" w-full h-full bg-white">
              <UserSelection
                title={"User"}
                setModel={setUserModal}
                setSelectedUsers={setUserInAppProfile}
              />
            </div>
          )}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Phone Number
          </label>
          <input
            type="text"
            name="phoneNumber"
            value={advertiserData.phoneNumber}
            onChange={handleChange}
            className=" block w-full rounded-md border border-blue-800 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Display Name
          </label>
          <input
            type="text"
            name="displayName"
            value={advertiserData.displayName}
            onChange={handleChange}
            className=" block w-full rounded-md border border-blue-800 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Description
          </label>
          <textarea
            type="text"
            name="description"
            rows={4}
            value={advertiserData.description}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border border-blue-800 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
          />
        </div>
        <div>
          <label
            className="block text-gray-700 font-medium mb-2"
            htmlFor="file">
            Display Picture
          </label>
          <input
            type="file"
            id="displayProfile"
            accept="image/*"
            multiple={false}
            onChange={(ev) => setDisplayProfile(ev.target.files[0])}
            className="w-full px-4 py-2 border rounded-md focus:outline-none"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-4 py-2 rounded-md">
          {advertiserId?"Edit":"Create "}
        </button>
      </form>
    </div>
  );
};

export default CreateAdvertiser;
